import { Component, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CommunityDTO } from 'src/app/DTO/CommunityDTO';
import { ApiService } from 'src/app/services/api.service';
import { CommunityService } from 'src/app/services/community/community.service';
import { ThemeService } from 'src/app/services/theme/theme.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {

  isIframe = false;
  public community?: CommunityDTO;
  isLoading = true;
  public hideColumn: boolean;
  public cssVariables = signal<string>('');

  constructor(
    private apiService: ApiService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private communityService: CommunityService,
    public themeService: ThemeService) {
      this.router.events.forEach((event) => {
        if (event instanceof NavigationEnd) {
          const segments = event.url.split('/');
          const isEvents = segments.includes('events');
          this.hideColumn = isEvents && segments.length > 3;
        }
      });
  }

  async ngOnInit() {
    let c = this.actRoute.snapshot.params['community'];

    this.isIframe = await this.themeService.getIsIframe();

    this.apiService.getCommunityByCode(c).subscribe(res => {
      if (res) {
        this.community = res;
        this.communityService.Set(this.community);
        this.cssVariables.set(ThemeService.getThemeCssVariablesByCommunity(this.community));
        this.themeService.applyThemeVariables(this.community);
        if(this.actRoute.children.length == 0) {
          this.getFirstPage();
        } else {
          this.isLoading = false;
        }
      } else {
        this.router.navigateByUrl('/error');
      }
    });
  }

  getFirstPage() {
    this.communityService.setMenuTabs()
      .then((res) => {
        if(res.length > 0) {
          this.router.navigateByUrl(`/${this.community.code}/${res[0].route}`)
        } else {
          this.router.navigateByUrl(`/${this.community.code}/events`);
        }
        this.isLoading = false;
      })
  }
}
